export default __webpack_public_path__ + "static/media/footfail.c78c42b0.svg";